
import {Component, Vue} from 'vue-property-decorator'
import SubTitle from './subTitle.vue'
import {getTaskList} from '@/api/home'

@Component({
	name: 'TaskStatus',
	components: {
		SubTitle
	}
})
export default class TaskStatus extends Vue {
	titleData = {
		title: '任务状态',
		subTitle: 'Task Status',
		icon: 'icon-daibanrenwu',
		color: '#4a9bfd',
		bg: '#e0efff',
		size: '34px'
	}
	iconList = [
		'活动专区',
		'盲盒专区',
		'Mobile Check',
		'Line',
		'WhatsApp',
		'Telegram',
		'Zalo',
		'Signal',
		'Skype',
		'Facebook',
		'Instagram',
		'Binance',
		'Linkedin',
		'Microsoft',
		'Twitter',
		'Amazon',
		'Viber',
		'成品代筛',
		'SnapChat',
		'kakaotalk',
		'Wish',
		'MoMo',
		'botim',
		'okx',
		'htx',
		'bybit',
		'mint',
		'gate',
		'platform-manage',
		'platform',
		'tiktok'
	]
	idList = [
		'active_',
		'blind',
		'phone',
		'line',
		'ws',
		'tg',
		'zalo',
		'signal',
		'skype',
		'fb',
		'ins',
		'binance',
		'linkedin',
		'ms',
		'twitter',
		'amazon',
		'viber',
		'agent',
		'snapchat',
		'kakao',
		'wish',
		'momo',
		'botim',
		'okx',
		'htx',
		'bybit',
		'mint',
		'gate',
		'event',
		'black',
		'tiktok'
	]
	listData = []

	mounted() {
		this.initTaskList()
	}

	initTaskList() {
		getTaskList()
			.then(res => {
				this.listData = []
				res.data.forEach((item: any) => {
					const index = this.idList.indexOf(item.Platform)
					this.listData.push({
						...item,
						path: this.iconList[index] && require(`@/assets/img/${this.iconList[index]}.png`)
					})
				})
				console.log(this.listData)
			})
			.catch(err => {
				console.log(err)
				this.$message.error(err.msg)
			})
	}
}
